export default "/credits/business/assets/d44a2d5fa7c3458d35dd0be24496a605.png";